import Collapse from "@quarkly/community-kit/Collapse";
export default Collapse;